import { useState } from 'react'

import { PayloadCepIntegration } from 'common/api'
import CepIcon from 'common/components/cepIcon/CepIcon'
import DistributionChannelIconList from 'common/components/distributionIconList/DistributionIconList'
import Widget from 'common/components/Widget'
import { DistributionChannel } from 'common/interfaces/projects'
import { CepTemplateFormatted } from 'features/admin/accountSettings/api/queries/useGetCepIntegrationTemplatesQuery'

import CreateCepIntegrationModal from '../createCepIntegrationWidget/CreateCepIntegrationModal'

type Props = {
  name: string
  cep: CepTemplateFormatted
  className?: string
  onSubmit: (payload: PayloadCepIntegration) => void
}

const IntegrationCardCepIntegration = ({ name, cep, onSubmit }: Props) => {
  const [isCreateWidgetVisible, setIsCreateWidgetVisible] =
    useState<boolean>(false)

  return (
    <Widget
      type="inner"
      className="border border-solid bg-gold-100 hover:bg-gold-300 p-5"
    >
      <div
        className="cursor-pointer"
        onClick={(e) => {
          setIsCreateWidgetVisible(true)
        }}
        role="button"
      >
        <div className="flex items-center gap-4">
          <CepIcon
            style={{ height: '50px', width: '50px' }}
            name={cep?.cepName!}
          />
          <div className="ml-auto">
            <DistributionChannelIconList
              distributionChannels={
                (cep?.distributionChannel.map(
                  (distributionChannel) => distributionChannel.name
                ) ?? []) as DistributionChannel[]
              }
            />
          </div>
        </div>

        <div className="text-coolGray-800 text-lg font-medium mt-2">{name}</div>
        <div className="text-coolGray-800 text-lg mt-4">
          {cep?.description ?? '<Description Missing in the template>'}
        </div>
      </div>
      {isCreateWidgetVisible && (
        <CreateCepIntegrationModal
          cep={cep}
          isCreateWidgetVisible={isCreateWidgetVisible}
          onClose={() => {
            setIsCreateWidgetVisible(false)
          }}
          onSubmit={onSubmit}
        />
      )}
    </Widget>
  )
}
export default IntegrationCardCepIntegration
